/**
 * Global counter for generating unique stack item keys.
 * Module-level ensures uniqueness across ALL stacks in the app.
 * Resets on page reload, which is fine since stacks reset too.
 */
let keyCounter = 0;

export function generateStackKey(): string {
  return `stack-${++keyCounter}`;
}
